<template lang="pug">
ClientOnly
    .group.h-screen(
        id="zSidebar"
        :class="{\
            'rsidebar': !coreStore.sidebarSmValue, \
            'rsidebar-md': coreStore.sidebarSmValue\
        }"
    )
        .flex.h-full.flex-grow.flex-col.text-neutral-300(
            class="transition duration-1000 ease-in-out transform-gpu slide-in-from-left"
            :class="{'bg-zinc-900': $route.name.includes('admin')}"
        )
            .flex.flex-1.flex-col
                .w-full.border-b(class="h-12 max-h-12")
                    .flex.self-center.flex-1(
                        class="h-12 max-h-12"
                        :class="{'justify-center': !coreStore.sidebarSmValue}"
                    )

                        //- ++++++++++++++++++++++++++++++++++
                        //- Custom Logo Here
                        //- ++++++++++++++++++++++++++++++++++
                        .flex.flex-1.flex-col.items-center(
                            v-if="!coreStore.sidebarSmValue"
                        )
                            NuxtLink(to="/")
                                DefaultLogo(sm)
                        .flex.flex-1.flex-col(
                            v-else
                        )
                            .flex.flex-1.items-center.justify-start
                                DefaultLogo

                //- +++++++++++++++++++++
                .flex.flex-1.h-full
                    DefaultSidebar

                .flex.flex-col.px-2(
                    :class="{'justify-center': !coreStore.sidebarSmValue}"
                )
                    .flex(
                        :class="{'justify-center': !coreStore.sidebarSmValue}"
                    )
                        UButton.font-normal(
                            to="/"
                            color="neutral"
                            :label="coreStore.sidebarSmValue ? 'Administrator' : ''"
                            size="md" variant="ghost" icon="heroicons:shield-check"
                        )

                    ClientOnly
                        .flex.flex-1.py-2(
                            :class="{'justify-center': !coreStore.sidebarSmValue}"
                        )
                            UButton.text-neutral-400.text-sm.font-normal(
                                v-if="coreStore.sidebarSmValue"
                                size="md"
                                variant="link"
                                color="neutral"
                                label="Collapse sidebar"
                                icon="heroicons:chevron-double-left-20-solid"
                                @click="coreStore.sidebarSm = !coreStore.sidebarSmValue"
                            )
                            UButton.text-neutral-400(
                                v-else
                                size="md"
                                block
                                color="neutral"
                                variant="ghost"
                                icon="heroicons:chevron-double-right-20-solid"
                                @click="coreStore.sidebarSm = !coreStore.sidebarSmValue"
                            )

</template>
<script setup lang="ts">
import { DefaultSidebar } from "#components";
const coreStore = useTemplateStore();
const router = useRouter();

router.beforeEach((to, from, next) => {
  coreStore.sidebarMob = false;
  next();
});
</script>
